/**
 * Single source of truth for the analytics tags that run on nougat.law.
 *
 * nougat.law is served by THIS repo's root CRA build only (see `dockerfile`:
 * `npm run build` -> /app/build -> nginx). The vendored `Atticus-Front-End/`
 * tree is not built or served by that image, and every other brand front-end
 * (LitigAI, family-law, personal-injury, SeriesAI) ships its own container from
 * its own repo.
 *
 * Therefore: exactly one GA4 property may be referenced from `src/`. The GA4 ID
 * belongs to Nougat; any build override that points
 * somewhere else disables GA4 instead of leaking traffic into another brand.
 *
 * `analyticsIds.test.js` enforces this invariant.
 */

const DEFAULT_GA_MEASUREMENT_ID = "G-WWTBQB43DS";
const DEFAULT_AHREFS_KEY = "9azKBry5PMuqOZIIe7xL4A";

const readEnv = (value) =>
  typeof value === "string" && value.trim() ? value.trim() : null;

// Nougat must not send traffic to the JuristAI GA4 property.
const configuredGaId = readEnv(process.env.REACT_APP_GA_MEASUREMENT_ID);
export const GA_MEASUREMENT_ID =
  configuredGaId === null || configuredGaId === DEFAULT_GA_MEASUREMENT_ID
    ? DEFAULT_GA_MEASUREMENT_ID
    : null;
export const AHREFS_KEY =
  readEnv(process.env.REACT_APP_AHREFS_KEY) || DEFAULT_AHREFS_KEY;

/**
 * Shared DOM ids for the injected tags. Every loader must reuse these so a
 * second call site cannot append a duplicate <script> for the same vendor.
 */
export const ANALYTICS_SCRIPT_IDS = {
  ahrefs: "juristai-ahrefs",
  googleAnalytics: "juristai-gtag",
};

export {
  DEFAULT_AHREFS_KEY,
  DEFAULT_GA_MEASUREMENT_ID,
};
